// src/constants/accessPermissions.js

export const ACCESS = {
  DASHBOARD: {
    VIEW_DASHBOARD: "view-dashboard",
    VIEW_DASHBOARD_PANEL: "view-dashboard-panel",
  },

  USER: {
    VIEW_USER_LIST: "view-user-list",
    VIEW_PROFILE: "view-user-profile",
  },

  VEHICLE_STOCK: {
    VIEW_VEHICLE_STOCK: "view-vehicle-stock",
  },
  BRAND: {
    VIEW_BRAND_LIST: "view-brand-list",
  },

  MODEL: {
    VIEW_MODEL_LIST: "view-model-list",
  },
  SETTINGS: {
    VIEW_SETTINGS_PANEL: "view-settings-panel",
  },

  LOCATION: {
    VIEW_LOCATION_LIST: "view-location-list",
  },

  STATUS: {
    VIEW_STATUS_LIST: "view-status-list",
  },

  COLOR: {
    VIEW_COLOR_LIST: "view-color-list",
  },

  FEATURE: {
    VIEW_FEATURE_LIST: "view-feature-list",
  },

  PACKAGE: {
    VIEW_PACKAGE_LIST: "view-package-list",
  },

  YEAR: {
    VIEW_YEAR_LIST: "view-year-list",
  },

  ENGINE_CC: {
    VIEW_ENGINE_CC_LIST: "view-engine-cc-list",
  },

  CHASSIS_CODE: {
    VIEW_CHASSIS_CODE_LIST: "view-chassis-code-list",
  },

  ENGINE_CODE: {
    VIEW_ENGINE_CODE_LIST: "view-engine-code-list",
  },

  FUEL_TYPE: {
    VIEW_FUEL_TYPE_LIST: "view-fuel-type-list",
  },

  ENGINE_TYPE: {
    VIEW_ENGINE_TYPE_LIST: "view-engine-type-list",
  },

  KEY_TYPE: {
    VIEW_KEY_TYPE_LIST: "view-key-type-list",
  },

  AUCTION_GRADE: {
    VIEW_AUCTION_GRADE_LIST: "view-auction-grade-list",
  },

  TRANSMISSION: {
    VIEW_TRANSMISSION_LIST: "view-transmission-list",
  },

  SHOWROOM: {
    VIEW_SHOWROOM_LIST: "view-showroom-list",
    VIEW_PROFILE: "view-showroom-profile",
  },

  STOCK: {
    VIEW_STOCK_LIST: "view-stock-list",
    CREATE: "create-stock",
    EDIT: "edit-stock",
    DELETE: "Delete Stock",
    VIEW_DETAILS: "view-stock-details",
    VIEW_IMPORTER: "view-stock-importer",
    CREATE_IMPORTER: "create-stock-importer",
    EDIT_IMPORTER: "edit-stock-importer",
    FILTER_IMPORTER: "filter-stock-importer",
    VIEW_STOCK_PUBLISHMENT: "view-stock-publishment",
    CREATE_STOCK_PUBLISHABLE_PLATFORM: "create-stock-publishable-platform",
    EDIT_STOCK_PUBLISHABLE_PLATFORM: "edit-stock-publishable-platform",
  },
  STOCK_PANEL: {
    VIEW_PANEL: "view-stock-panel",
  },

  MESSAGE: {
    VIEW_CONTACT_MESSAGE_LIST: "view-contact-message-list",
  },
  VEHICLE_MOVEMENT_TYPE: {
    VIEW_LIST: "view-vehicle-movement-type-list",
    VIEW: "view-vehicle-movement-type",
    EDIT: "edit-vehicle-movement-type",
    DELETE: "delete-vehicle-movement-type",
  },
  VEHICLE_MOVEMENT: {
    VIEW_LIST: "view-vehicle-movement-list",
    VIEW_KEY_LIST: "view-vehicle-movement-key-list",
    VIEW: "view-vehicle-movement",
    EDIT: "edit-vehicle-movement",
    DELETE: "delete-vehicle-movement",
  },
  VEHICLE_FUEL_PANEL: {
    VIEW: "view-vehicle-fuel-panel",
  },
  VEHICLE_FUEL_STOCK: {
    VIEW_LIST: "view-vehicle-fuel-stock-list",
    VIEW: "view-vehicle-fuel-stock",
    EDIT: "edit-vehicle-fuel-stock",
    DELETE: "delete-vehicle-fuel-stock",
  },
  VEHICLE_FUEL_USE: {
    VIEW_LIST: "view-vehicle-fuel-use-list",
    VIEW: "view-vehicle-fuel-use",
    EDIT: "edit-vehicle-fuel-use",
    DELETE: "delete-vehicle-fuel-use",
  },

  VEHICLE_MOVEMENT_PANEL: {
    VIEW: "view-vehicle-movement-panel",
  },

  ROLE: {
    VIEW_ROLE_LIST: "view-role-list",
  },
  PERMISSION: {
    VIEW_PERMISSION_LIST: "view-permission-list",
  },
  MODULE: {
    VIEW_MODULE_LIST: "view-module-list",
  },

  ROLE_PERMISSION: {
    VIEW_ROLE_PERMISSION: "view-role-permission",
    VIEW_MODULES: "view-modules",
    VIEW_ROLES: "view-roles",
    VIEW_PERMISSIONS: "view-permissions",
    ASSIGN_ROLE_PERMISSIONS: "assign-permissions-to-role",
  },
  VEHICLE_IMPORTER: {
    VIEW_VEHICLE_IMPORTER_LIST: "view-vehicle-importer-list",
    VIEW_VEHICLE_IMPORTER: "view-vehicle-importer",
    CREATE_VEHICLE_IMPORTER: "create-vehicle-importer",
    EDIT_VEHICLE_IMPORTER: "edit-vehicle-importer",
    DELETE_VEHICLE_IMPORTER: "delete-vehicle-importer",
    RESTORE_VEHICLE_IMPORTER: "restore-vehicle-importer",
    FORCE_DELETE_VEHICLE_IMPORTER: "force-delete-vehicle-importer",
  },
  CONTENT_MANAGER: {
    VIEW_CONTENT_MANAGER: "view-content-manager",
    VIEW_VEHICLE_CONTENT_LIST: "view-vehicle-content-list",
  },
  VEHICLE_CONTENT: {
    VIEW_VEHICLE_CONTENT_LIST: "view-vehicle-content-list",
    ADD_VEHICLE_CONTENT: "add-vehicle-content",
    EDIT_VEHICLE_CONTENT: "edit-vehicle-content",
    DELETE_VEHICLE_CONTENT: "delete-vehicle-content",
  },

  JOB: {
    VIEW_GRID: "view-jobs",
    VIEW_DETAILS: "view-job-details",
    VIEW_CATEGORIES: "view-job-categories",
    APPLY: "apply-jobs",
    VIEW_CANDIDATES: "view-candidates",
    VIEW_CANDIDATE_DETAILS: "view-candidate-details",
  },
  CUSTOMER_PANEL: {
    VIEW: "view-customer-panel",
  },
  CUSTOMER: {
    VIEW_LIST: "view-customer-list",
    ADD: "add-customer",
    EDIT: "edit-customer",
    DELETE: "delete-customer",
  },
  CUSTOMER_DESIGNATION: {
    VIEW_LIST: "view-customer-designation-list",
    ADD: "add-customer-designation",
    EDIT: "edit-customer-designation",
    DELETE: "delete-customer-designation",
  },
  CUSTOMER_DEPARTMENT: {
    VIEW_LIST: "view-customer-department-list",
    ADD: "add-customer-department",
    EDIT: "edit-customer-department",
    DELETE: "delete-customer-department",
  },
  CUSTOMER_COMPANY: {
    VIEW_LIST: "view-customer-company-list",
    ADD: "add-customer-company",
    EDIT: "edit-customer-company",
    DELETE: "delete-customer-company",
  },
  CUSTOMER_AREA: {
    VIEW_LIST: "view-customer-area-list",
    ADD: "add-customer-area",
    EDIT: "edit-customer-area",
    DELETE: "delete-customer-area",
  },
  CUSTOMER_CITY: {
    VIEW_LIST: "view-customer-city-list",
    ADD: "add-customer-city",
    EDIT: "edit-customer-city",
    DELETE: "delete-customer-city",
  },
  CUSTOMER_TYPE: {
    VIEW_LIST: "view-customer-type-list",
    ADD: "add-customer-type",
    EDIT: "edit-customer-type",
    DELETE: "delete-customer-type",
  },
  // Accessories Management
  ACCESSORIES_MANAGEMENT: {
    VIEW: "view-accessories-management-panel",
  },

  ACCESSORIES: {
    VIEW_LIST: "view-accessories-list",
    ADD: "add-accessories",
    EDIT: "edit-accessories",
    DELETE: "delete-accessories",
  },
  ACCESSORIES_COMPANY: {
    VIEW_LIST: "view-accessories-company-list",
    ADD: "add-accessories-company",
    EDIT: "edit-accessories-company",
    DELETE: "delete-accessories-company",
  },
  ACCESSORIES_STOCK: {
    VIEW_LIST: "view-accessories-stock-list",
    ADD: "add-accessories-stock",
    EDIT: "edit-accessories-stock",
    DELETE: "delete-accessories-stock",
  },
  UNIT: {
    VIEW_LIST: "view-unit-list",
    ADD: "add-unit",
    EDIT: "edit-unit",
    DELETE: "delete-unit",
  },
  ACCESSORIES_USAGE: {
    VIEW_LIST: "view-accessories-use-list",
    ADD: "add-accessories-use",
    EDIT: "edit-accessories-use",
    DELETE: "delete-accessories-use",
  },
}
